module.exports = __webpack_public_path__ + "static/img/wechat_login.00200eb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/wechat_login.png
// module id = ZK0c
// module chunks = 1